import { render } from "./Footer.vue?vue&type=template&id=1b9b8bb4&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=1b9b8bb4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1b9b8bb4"

export default script